import {Component, inject, viewChild, Signal, ViewEncapsulation} from '@angular/core';
import {CrudControlComponent} from 'frontier/browserkit';
import {ProcessOverviewStore} from '../../service/process-overview.store';
import {combineLatest, Observable, Subject} from 'rxjs';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';
import {ICart} from '../../service/state.interface';
import {NgFor} from '@angular/common';
import {CrudCartAdditionaldataService} from 'src/app/api/generated';
import AppControlGuids from '../../../../../api/ControlGuids';

@Component({
  selector: 'kpi4me-cart-additional-detail',
  templateUrl: './cart-additional-detail.component.html',
  styleUrls: ['./cart-additional-detail.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [CrudControlComponent, NgFor],
})
export class CartAdditionalDetailComponent {
  private _crudCartAdditionalData: CrudCartAdditionaldataService = inject(CrudCartAdditionaldataService);
  cartAdditionalDataGuid: string = AppControlGuids.TCrudCartAdditionaldata;
  private _processOverviewService: ProcessOverviewStore = inject(ProcessOverviewStore);
  selectedCart$: Observable<ICart> = toObservable(this._processOverviewService.selectedCart);
  apiInitialized$: Subject<void> = new Subject<void>();

  crudControl: Signal<CrudControlComponent> = viewChild(CrudControlComponent);
  labels: string[];

  constructor() {
    combineLatest([
      this.selectedCart$,
      this.apiInitialized$]
    ).pipe(takeUntilDestroyed())
      .subscribe(([selectedCart]) => {
        this.filterAndFetch(selectedCart);
      });
  }

  onApiInstanceInitialize(): void {
    this.labels = [
      'Text:',
      '',
      'Notfallart:',
      '',
      'Rückfahrt:',
      '',
      'NEF nachgefordert:',
      '',
      'Fehlfahrt:',
      '',
      'Versuchter Transport:',
      '',
    ];
    this.apiInitialized$.next();
  }

  private filterAndFetch(selectedCart: ICart): void {
    this._crudCartAdditionalData.crudCartAdditionaldataGetObject({
      ObjectId: selectedCart.obj,
    })
      .subscribe((res) => {
        console.log(res);
        if (res) {
          this.labels[1] = res.text;
          this.labels[3] = res.stat1;
          this.labels[5] = res.hinrueck === 'F' ? 'nein' : res.hinrueck === 'T' ? 'ja' : '';
          this.labels[7] = res.mitnef === 'F' ? 'nein' : res.mitnef === 'T' ? 'ja' : '';
          this.labels[9] = res.fehlfahrt === 'F' ? 'nein' : res.fehlfahrt === 'T' ? 'ja' : '';
          this.labels[11] = res.versuchttransport === 'F' ? 'nein' : res.versuchttransport === 'T' ? 'ja' : '';
        } else {
          this.labels[1] = 'keine Daten';
          this.labels[3] = 'keine Daten';
          this.labels[5] = 'keine Daten';
          this.labels[7] = 'keine Daten';
          this.labels[9] = 'keine Daten';
          this.labels[11] = 'keine Daten';
        }
        this.crudControl().cdr.detectChanges();
      });
  }
}
